<nav class="nav" aria-label="Seções das configurações">
  <h2 id="dialogo-configuracoes-titulo" class="title">Configurações</h2>

  <div class="sections">
    @for (item of sections; track item.id) {
      <button
        type="button"
        class="section"
        [attr.aria-current]="item.id === section().id ? 'page' : null"
        [attr.cdkFocusInitial]="item.id === section().id ? '' : null"
        (click)="sectionId.set(item.id)"
      >
        <svg-icon aria-hidden="true" [src]="item.icon" />
        {{ item.label }}
      </button>
    }
  </div>
</nav>

<div class="main">
  <header class="header">
    <h3>{{ section().label }}</h3>
    <p>{{ section().description }}</p>

    <button type="button" class="icon-btn close" aria-label="Fechar" appTooltip="Fechar" (click)="dialogRef.close()">
      <svg-icon src="assets/mdi/close.svg" aria-hidden="true" />
    </button>
  </header>

  <div class="body">
    <ng-container *ngComponentOutlet="section().component" />
  </div>

  <footer class="footer">
    <span class="saved">
      <svg-icon src="assets/mdi/check.svg" aria-hidden="true" />
      <span>Salvo automaticamente</span>
    </span>

    <button type="button" class="btn btn-ghost btn-sm reset" (click)="resetDefaults()">
      <svg-icon src="assets/mdi/restore.svg" aria-hidden="true" />
      Restaurar padrões
    </button>
  </footer>
</div>
